// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/inventory-detail.less
// module id = 3465
// module chunks = 0